import {configure as configureUikit} from '@gravity-ui/uikit';
import {configure as configureCommon} from '@yandex-data-ui/common';
import {configure as configureNavigation} from '@yandex-data-ui/navigation';
import {setConfig as configureCloudComponents} from '@yandex-data-ui/cloud-components';

import {lang} from '~ui/constants/ui-lang';

configureUikit({lang});
configureCommon({lang});
configureNavigation({lang});
configureCloudComponents({lang});
